import * as React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import joinChannelWithToken from 'shared/graphql/mutations/channel/joinChannelWithToken';
import { addToastWithTimeout } from 'src/actions/toasts';
import { CLIENT_URL } from 'src/api/constants';

import { withCurrentUser } from 'src/components/withCurrentUser';
import { LoadingView, ErrorView } from 'src/views/viewHelpers';

class PrivateChannelJoin extends React.Component {
  state = {
    isLoading: false,
  };

  componentDidMount() {
    const { match, history, currentUser } = this.props;
    const { token, communitySlug, channelSlug } = match.params;

    if (!token) {
      return history.push(`/${communitySlug}/${channelSlug}`);
    }

    if (!currentUser) {
      return;
    }

    return this.handleJoin();
  }

  componentDidUpdate(prevProps) {
    const curr = this.props;

    if (!prevProps.currentUser && curr.currentUser) {
      return this.handleJoin();
    }
  }

  handleJoin = () => {
    const { match, history, joinChannelWithToken, dispatch } = this.props;
    const { token, communitySlug, channelSlug } = match.params;

    this.setState({ isLoading: true });

    joinChannelWithToken({ channelSlug, token, communitySlug })
      .then(() => {
        this.setState({ isLoading: false });
        dispatch(addToastWithTimeout('success', 'Welcome!'));
        return history.push(`/${communitySlug}/${channelSlug}`);
      })
      .catch(err => {
        this.setState({ isLoading: false });
        dispatch(addToastWithTimeout('error', err.message));
        return history.push(`/${communitySlug}/${channelSlug}`);
      });
  };

  render() {
    const { currentUser, match } = this.props;
    const { isLoading } = this.state;

    const {
      params: { communitySlug, channelSlug, token },
    } = match;

    const redirectPath = `${CLIENT_URL}/${communitySlug}/${channelSlug}/join/${token}`;
    // FIXME: DENDI
    // if (!currentUser || !currentUser.id) {
    //   return <CommunityLogin match={match} redirectPath={redirectPath} />;
    // }

    if (isLoading) return <LoadingView />;

    return <ErrorView />;
  }
}

export default compose(
  withCurrentUser,
  joinChannelWithToken,
  connect()
)(PrivateChannelJoin);
